var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield13(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.98 2.5v19c-.04 0-.09 0-.13-.02-.07-.02-7.67-2.4-7.67-8.81 0-1.83-.03-3.16-.05-4.13-.04-2.4-.05-2.84.51-3.4.71-.7 6.28-2.62 7.34-2.64z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.87 8.55c-.02.97-.05 2.29-.05 4.12 0 6.41-7.6 8.79-7.67 8.81-.05.02-.1.02-.15.02h-.02v-19H12c1.02 0 6.65 1.94 7.36 2.64.56.56.55 1 .51 3.41z",
    fill: "currentColor"
  })));
}
export default SvgShield13;